// extracted by mini-css-extract-plugin
module.exports = {"textEditor":"TextEditor_textEditor__3FYL2"};